import React, { StrictMode } from 'react';
import {createRoot} from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router';
import "./styles/global.css";
import { initializeApp } from "firebase/app";
import Work from "./01-work/index";
import About from "./02-about/index";
import Resume from "./03-resume/index";
import Error404 from "./04-404/index";
import Contact from "./05-contact/index";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SouthwestAppRedesign from './01-work/southwest-app-redesign';
import DignifiAppDesign from './01-work/dignifi-app-design';
import SmartHomeInfograhpic from './01-work/smart-home-infographic';
import InsightARAppDesign from './01-work/insight-ar-app-design';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCq06PE4FIRKOFfxfVR1C1Ont4wlV-4NNA",
  authDomain: "portfolio-2025-6463c.firebaseapp.com",
  projectId: "portfolio-2025-6463c",
  storageBucket: "portfolio-2025-6463c.firebasestorage.app",
  messagingSenderId: "296101569303",
  appId: "1:296101569303:web:d4fb0aa0fed82c6752cd52"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

root.render(
  <StrictMode>
    <BrowserRouter>
      <Header/>
      <Routes>
        <Route path="/" element={<Work/>}/>
        <Route path="work" element={<Work/>}/>
        <Route path="about" element={<About/>}/>
        <Route path="resume" element={<Resume/>}/>
        <Route path="contact" element={<Contact/>}/>
        <Route path="southwest-app-redesign" element={<SouthwestAppRedesign/>}/>
        <Route path="dignifi-app-design" element={<DignifiAppDesign/>}/>
        <Route path="smart-home-infographic" element={<SmartHomeInfograhpic/>}/>
        <Route path="insight-ar-app-design" element={<InsightARAppDesign/>}/>
        <Route path="*" element={<Error404/>}/>
      </Routes>
      <Footer/>
    </BrowserRouter>
  </StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
